/** Allowed countries for the VO2 Maxxin' Challenge hero carousel slide. */
export const VO2_MAX_BANNER_COUNTRIES: readonly string[] = ['IN'] as const;

/** Challenge runs June 1 – June 10, 2026, Bangalore (IST). */
export const VO2_MAX_CHALLENGE_START_AT = '2026-06-01T00:00:00+05:30';
export const VO2_MAX_CHALLENGE_END_AT = '2026-06-10T23:59:59+05:30';

/** Public Typeform that captures registrations. */
export const VO2_MAX_CHALLENGE_TYPEFORM_ID = 'IczDSXEd';

/** Performance Lab tour booking Typeform (book a visit). */
export const PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_ID = 'oGvGBH7o';

/** Performance Lab "Book a callback" Typeform (navbar + diagnostics hero CTAs). */
export const PERFORMANCE_LAB_CALLBACK_TYPEFORM_ID = 'Og8Yhtd2';

/** Live challenge leaderboard (region routing applied via CustomLink). */
export const VO2_MAX_LEADERBOARD_PATH = '/performance-lab/leaderboard';

export const isVo2MaxBannerCountry = (country?: string | null): boolean => {
  if (!country) return false;
  return VO2_MAX_BANNER_COUNTRIES.includes(country.toUpperCase());
};
